import React from 'react';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';
import { PodigeeComponent } from '@src/interfaces';
import PodigeeItem from "@src/components/Podigee/PodigeeItem";

const PodigeeParagraph = (props: ParagraphProps) => {
  const podigeeProps = props.paragraph.data as PodigeeComponent;
  return <PodigeeItem {...podigeeProps} />
};

export default PodigeeParagraph;
